import {
  BorderPosition,
  PortalBorderType,
  PortalClassStateOrMedia,
  PortalSolidColor,
  PortalStyleConfig,
  ThemeColorSchemas,
} from '@nx-frontend/shared/types';
import { getRoundedClassNames } from './getRounded';
import { getClassNamePrefix, getColorSchemaPrefix } from './getTheme';

interface BorderOptions {
  states?: PortalClassStateOrMedia[];
  position?: BorderPosition;
  rounded?: boolean;
}

export function getBorderClassNames(
  themeColors: ThemeColorSchemas,
  themeStyle: PortalStyleConfig,
  type: PortalBorderType | PortalSolidColor,
  { states = [], position, rounded }: BorderOptions = {}
): string[] {
  const {
    border: { className },
  } = themeStyle;

  if (!className.length || className.includes('border-0')) {
    return [];
  }

  const state = getClassNamePrefix(states);
  const classNames: string[] = position == null ? [...className] : [position];

  // Temporarily add theme variable names for design purposes
  if (typeof type === 'string') {
    classNames.push(['_THEME', ...states, type].join(':'));
  }

  return themeColors.reduce((classNames, { schema, colors }) => {
    const [color] = typeof type === 'string' ? colors[type] : type;
    const prefix = getColorSchemaPrefix(schema) + state;
    classNames.push(`${prefix}border-${color}`);
    if (rounded === true) {
      classNames.push(...getRoundedClassNames(themeStyle));
    }
    return classNames;
  }, classNames);
}
